import React from "react";
import LineOrange from "../../../common/LineOrange/LineOrange";
import styles from "../style.module.css";

export const Certificate = () => {
  return (
    <>
      <div className="container">
        <div className="text-center mb-5 mt-5">
          <h3>عرضه و پذیرش، مسیر ورود به بورس</h3>
          <LineOrange />
          <div className="">
            <p className="text-right mt-3">
              بازار سرمایه به عنوان یکی از ارکان اقتصاد کشور نقش مهمی در جذب پس
              اندازها و منابع مالی کوچک مردم و تخصیص آنها در جهت تامین مالی
              طرحهای بزرگ اقتصادی دارد تردیدی نیست که رشد اقتصادی توسعه رفاه و
              عدالت اجتماعی و گسترش ساز و کارهای تامین مالی در گرو رشد بازار
              سرمایه به تناسب سایر اجزای سیستم اقتصادی است ورود شرکتها به بورس
              ضمن کمک به رشد بازار سرمایه به تعالی و رشد آنها در فضایی رقابتی و
              شفاف منجر شده و نام و اعتبار آنها را در جامعه ترقی می بخشد. براساس
              مقررات بازار سرمایه، شرکت‌هایی که متقاضی پذیرش اوراق بهادار خود در
              بورس یا بازار خارج از بورس هستند، تمام یا بخشی از وظایف خود در
              فرآیند پذیرش را از طریق مشاوران پذیرش دارای مجوز از سازمان بورس و
              اوراق بهادار بورس انجام می‌دهند. به بیان دیگر مشاوران پذیرش، به
              عنوان رابط میان ناشران اوراق بهادار متقاضی پذیرش و بورس‌ها عمل
              می‌کنند. شرکت ها می‌توانند در بازار بورس تهران و یا فرابورس، تحت
              نظارت سازمان بورس و اوراق بهادار مورد پذیرش و عرضه قرار گیرند.
            </p>
            <img
              src={
                "/asset/images/123.png"
              } 
              className={styles.transaction_img}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};
